var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DocumentDownload component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDocumentDownload extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.65354 2.64001C4.47659 2.64001 4.30688 2.71031 4.18175 2.83544C4.05662 2.96056 3.98633 3.13027 3.98633 3.30723V18.8966C3.98633 19.0736 4.05662 19.2433 4.18175 19.3684C4.30688 19.4935 4.47659 19.5638 4.65354 19.5638H7.41996C7.83418 19.5638 8.16996 19.8996 8.16996 20.3138C8.16996 20.728 7.83418 21.0638 7.41996 21.0638H4.65354C4.07876 21.0638 3.52752 20.8355 3.12109 20.4291C2.71466 20.0226 2.48633 19.4714 2.48633 18.8966V3.30723C2.48633 2.73245 2.71466 2.18121 3.12109 1.77478C3.52752 1.36835 4.07876 1.14001 4.65354 1.14001H11.7396C11.9385 1.14001 12.1293 1.21903 12.27 1.35968L19.356 8.44576C19.4967 8.58641 19.5757 8.77718 19.5757 8.97609V9.22585C19.5757 9.64006 19.2399 9.97585 18.8257 9.97585C18.4329 9.97585 18.1106 9.67387 18.0784 9.28941L11.429 2.64001H4.65354Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.458 14.5583C16.458 14.1441 16.1222 13.8083 15.708 13.8083C15.2938 13.8083 14.958 14.1441 14.958 14.5583V17.904L14.0609 17.1229C13.7485 16.8509 13.2747 16.8836 13.0027 17.196C12.7307 17.5084 12.7635 17.9821 13.0759 18.2541L15.2156 20.1172C15.4979 20.363 15.9182 20.363 16.2006 20.1172L18.3405 18.2541C18.6529 17.9822 18.6856 17.5084 18.4136 17.196C18.1417 16.8836 17.6679 16.8508 17.3555 17.1228L16.458 17.9042V14.5583Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.7084 12.7499C13.3308 12.7499 11.4033 14.6773 11.4033 17.055C11.4033 19.4326 13.3308 21.3601 15.7084 21.3601C18.086 21.3601 20.0135 19.4326 20.0135 17.055C20.0135 14.6773 18.086 12.7499 15.7084 12.7499ZM9.90332 17.055C9.90332 13.8489 12.5023 11.2499 15.7084 11.2499C18.9145 11.2499 21.5135 13.8489 21.5135 17.055C21.5135 20.261 18.9145 22.8601 15.7084 22.8601C12.5023 22.8601 9.90332 20.261 9.90332 17.055Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDocumentDownload.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentDownload.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentDownload.prototype, "size", void 0);
if (customElements.get('cat-icon-document-download') === undefined) {
    customElements.define('cat-icon-document-download', BlocksIconDocumentDownload);
}
